module.exports = __webpack_public_path__ + "assets/img/preview.79d7dacd.png";